module.exports = __webpack_public_path__ + "static/media/case1.9a5034f5.png";